import React, { useEffect, useMemo, useState } from 'react';
import { Tooltip, Modal, Select, Row, Col } from 'antd';
import { Button, ColumnProps, Icon, notification, Table } from '@digital/ui';
import '../custom.css';
import ModalIncluirVendor from './ModalIncluirVendor';
import { deleteSasProposta, envioInformacoesCes, getPropostasOrdemCompraDocs, ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, responderCartaConvite, responderSolicitacaoEnvioEsclarecimentosTecnicos, responderVisitaTecnica, SasProposta, updateCheckDocumentacao, updatePropostaResultado, updateVerdorVencedor } from '@app/api/sas/sasProposta';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { allStepsState, dadosGeraisState, dadosIdentificacaoState, desabilitarAcoesState, editandoState, gerenteAreaOptionsState, gestorOptionsState, modalAcoesIdState, ordemCompraIdState, ordemCompraRodadaNegociacaoIdState, reloadState, reloadVendorListState, reloadWidgetTimelineState, showModalDesobrigarConfideIdState, stepState, vendorListState } from "../atoms";
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { EStatusCartaConvite, EStatusResultadoAvaliacaoComercial, EStatusSolicitacaoEsclarecimentosTecnicos } from '@app/enums';
import { ModalInclusaoMultAnexo, Space, Visibility } from '@app/components';
import { isObjNotEmpty, isObjEmpty, vtCloneObj } from '@app/helpers/objHelper';
import { downloadArquivo, downloadArquivosOrdemCompra, getArquivosDocumentoOrdemCompraByOc, incluirDocumento, viewArquivo } from '@app/api/sas/sasDocumentoOrdemCompra';
import ModalEditarVendor from './ModalEditarVendor';
import { EGuidStatusSasProposta } from '@app/enums/EGuidStatusSasProposta';
import { UploadModalHistorico } from '@app/components/Upload/uploadModalHistorico';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';
import { IArquivo } from '@app/types/core.types';
import { getByText, optionsAvaliacaoSasPropostaTecnica } from '@app/helpers/optionsSwitch';
import ModalRecebimentoPropostaTecnica from './ModalRecebimentoPropostaTecnica';
import ModalExibicaoArquivos from '../WidgetDocumentacao/ModalExibicaoArquivos';
import ModalParecerTecnico from './ModalParecerTecnico';
import ModalAcoesCompradorParecerTecnico from './ModalAcoesCompradorParecerTecnico';
import ModalPropostaTecnicaConsolidada from './ModalPropostaTecnicaConsolidada';
import ModalHomologacao from './ModalHomologacao';
import ModalEnviarConfide from './ModalEnviarConfide';
import ModalDesobrigarConfide from './ModalDesobrigarConfide';
import ModalEnvioDPC from './ModalEnvioDPC';
import ButtonConfirmarPropostaComercial from './ModalsPropostaComercial/ButtonConfirmarPropostaComercial';
import ModalNaoRecebimentoPropostaTecnica from './ModalNaoRecebimentoPropostaTecnica';
import { BotoesSasPropostaRodadaNegociacao } from './BotoesSasPropostaRodadaNegociacao';
import ModalParecerDPC from './ModalParecerDPC';
import { EResultadoEnvioConfide, EStatusRelatorioConfide, EStatusSolicitacaoAvaliacaoFinanceira } from '@app/enums/EResultadoEnvioConfide';
import { ModalStatusRelatorioConfide } from './ModalStatusRelatorioConfide';
import { ModalSolicitacaoAvaliacaoFinanceira } from './ModalSolicitacaoAvaliacaoFinanceira';
import { ModalCadastroResultadoAvaliacaoFinanceira } from './ModalCadastroResultadoAvaliacaoFinanceira';
import { ModalConfirmarSolicitacaoChancelaGJMinuta } from './ModalConfirmarSolicitacaoChancelaGJMinuta';
import { ModalRegistroSolicitacaoChancelaGJMinuta } from './ModalRegistroSolicitacaoChancelaGJMinuta';
import { BotoesEnvioNegociacaoMinutaContratual } from './BotoesEnvioNegociacaoMinutaContratual';
import { ModalValidarMinutaEnvioNegociacaoMinutaContratual } from './ModalValidarMinutaEnvioNegociacaoMinutaContratual';
import { isValidGuid } from '@app/helpers/geradorGuid';
import ModalAcoesGerais from '../AbaFluxoProcesso/ModalAcoesGerais';
import { currencyFormat } from "@app/helpers/numbers";
import { ModalDispensarSolicitacaoChancelaGJMinuta } from './ModalDispensarSolicitacaoChancelaGJMinuta';
import ModalEditarVendorStatus from './ModalEditarVendorStatus';
import { avancarOrdemCompra, getAllOrIdGerenteAreaOptions, getAllOrIdGestorTecnicoOptions } from '@app/api/sas/ordemCompra';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import ModalEnvioComunicacaoContratada from './ModalEnvioComunicacaoContratada';
import ModalDesobrigarRelatorioFinanceiro from './ModalDesobrigarRelatorioFinanceiro';
import { ModalComunicacaoMinutaContratualFornecedor } from './ModalComunicacaoMinutaContratualFornecedor';

const { confirm } = Modal;

interface Props {
  statusCodigo: number;
  onUpdateDadosGerais: () => any;
  ehComprador: boolean;
  fornecedorOcId?: string;
}

const TableVendorList: React.FC<Props> = ({
  statusCodigo,
  onUpdateDadosGerais,
  ehComprador,
  fornecedorOcId
}: Props) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);
  const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);
  const step = useRecoilValue(stepState);
  const allSteps = useRecoilValue(allStepsState);
  const dadosIdentificacao = useRecoilValue(dadosIdentificacaoState);
  const dadosGerais = useRecoilValue(dadosGeraisState);
  const showModalDesobrigarConfideId = useRecoilValue(showModalDesobrigarConfideIdState);
  const editando = useRecoilValue(editandoState);
  const [vendorList, setVendorList] = useRecoilState(vendorListState);
  const [reload, setReload] = useRecoilState(reloadState);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);

  const setGestorOptions = useSetRecoilState(gestorOptionsState);
  const setGerenteAreaOptions = useSetRecoilState(gerenteAreaOptionsState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);

  const [data, setData] = useState<ISasPropostaOrdemCompra[]>([]);
  const [tmpIdAcoes, setTmpIdAcoes] = useState<string[]>([]);
  const [rodadaPasso, setRodadaPasso] = useState({});

  const [docs, setDocs] = useState<ISasPropostaOrdemCompraDocs[]>([]);

  const ehAditivo = dadosGerais.tipo === ETipoDemanda.Aditivo;

  const onReloadVendorList = () => {
    setReloadVendorList(!reloadVendorList);
  };

  useEffect(() => {
    if (!ordemCompraId) return;
    getAllOrIdGestorTecnicoOptions()
      .then(data => {
        setGestorOptions(data);
      });

    getAllOrIdGerenteAreaOptions()
      .then(data => {
        setGerenteAreaOptions(data);
      });
  }, [ordemCompraId]);

  useEffect(() => {
    if (ordemCompraId) {
      setData(vendorList);
    }
  }, [ordemCompraId, vendorList]);

  useEffect(() => {
    setTmpIdAcoes([]);
  }, []);


  useEffect(() => {
    if (vendorList) {
      if (fornecedorOcId && isValidGuid(fornecedorOcId)) {
        const result = vtCloneObj(vendorList).filter((a: any) => a.sasFornecedorOcId == fornecedorOcId);
        setVendorList(result);
      }
    }
  }, [vendorList]);
  // reloadactions
  // useEffect(() => {
  //   if (modalAcoesId === '' || modalAcoesId === undefined) {
  //     onReloadVendorList();
  //   }
  // }, [modalAcoesId]);
  const aceitarCartaConvite = async (idRecord: string, values: any): Promise<boolean> => {
    let result = false;
    const form = new FormData();
    form.append('id', idRecord);
    form.append('resposta', 'true');
    values.arquivos.map((c: any, i: any) => {
      form.append(`arquivos`, c);
    });

    if (editando.sasPropostaId == idRecord) {
      Modal.confirm({
        title: <>{editando.justificativa}</>,
        content: <ModalConfirmContentJustificativa
          texto='É necessário informar a justificativa para a alteração.'
          setJustificativa={e => {
            form.set('justificativaEdicao', e);
          }}
        />,
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk: async () => {
          form.append('editando', 'true');
          return new Promise((resolve, reject) => {
            responderCartaConvite(form)
              .then((data: any) => {
                if (data && data.valid) {
                  onReloadVendorList();
                  setModalAcoesId('');
                  return resolve(true);
                } else {
                  if (data.notifications && data.notifications.length > 0) {
                    const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                      return c.property == 'justificativaEdicao';
                    });
                    if (erroJustificativaEdicao >= 0) {
                      return reject();
                    }
                  }
                }
              });
          });
        },
        onCancel: () => { setModalAcoesId(''); }
      });
    } else {
      const data = await responderCartaConvite(form);
      if (data && data.valid) {
        onReloadVendorList();
        result = true;
      }
    }

    return result;
  };

  const rejeitarCartaConvite = async (idRecord: string, values: any): Promise<boolean> => {
    let result = false;
    const form = new FormData();
    form.append('id', idRecord);
    form.append('justificativa', values.justificativa);
    form.append('resposta', 'false');
    values.arquivos.map((c: any, i: any) => {
      form.append(`arquivos`, c);
    });

    if (editando.sasPropostaId == idRecord) {
      Modal.confirm({
        title: <>{editando.justificativa}</>,
        content: <ModalConfirmContentJustificativa
          texto='É necessário informar a justificativa para a alteração.'
          setJustificativa={e => {
            form.set('justificativaEdicao', e);
          }}
        />,
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk: async (e) => {
          form.append('editando', 'true');
          return new Promise<void>((resolve, reject) => {
            responderCartaConvite(form)
              .then((data: any) => {
                if (data && data.valid) {
                  onReloadVendorList();
                  result = true;
                  return resolve();
                } else {
                  if (data.notifications && data.notifications.length > 0) {
                    const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                      return c.property == 'justificativaEdicao';
                    });
                    if (erroJustificativaEdicao >= 0) {
                      return reject();
                    }
                  }
                }
              });
          });
        },
        onCancel: () => { setModalAcoesId(''); }
      });
    } else {
      await responderCartaConvite(form)
        .then((data: any) => {
          if (data && data.valid) {
            onReloadVendorList();
            result = true;
          }
        });
    }
    return result;
  };

  const aceitarVisitaTecnica = async (idRecord: string, values: any): Promise<boolean> => {
    let result = false;
    const form = new FormData();
    form.append('id', idRecord);
    form.append('resposta', 'true');
    values.arquivos.map((c: any, i: any) => {
      form.append(`arquivos`, c);
    });
    await responderVisitaTecnica(form)
      .then((data: any) => {
        if (data && data.valid) {
          onReloadVendorList();
          result = true;
        }
      });

    return result;
  };

  const rejeitarVisitaTecnica = async (idRecord: string, values: any): Promise<boolean> => {
    let result = false;
    const form = new FormData();
    form.append('id', idRecord);
    form.append('justificativa', values.justificativa);
    form.append('resposta', 'false');
    values.arquivos.map((c: any, i: any) => {
      form.append(`arquivos`, c);
    });
    await responderVisitaTecnica(form)
      .then((data: any) => {
        if (data && data.valid) {
          onReloadVendorList();
          result = true;
        }
      });

    return result;
  };

  const aceitarSolicitacaoEnvioEsclarecimentosTecnicos = async (record: ISasPropostaOrdemCompra, values: any) => {

    if (values && isObjEmpty(values.arquivo)) {
      notification.error('É necessário anexar o arquivo de esclarecimento técnico.');
      return false;
    }

    const form = new FormData();
    form.append('sasPropostaId', record.id);

    if (isObjNotEmpty(docs) &&  docs[0].anexoSolicitacaoEsclarecimentosTecnicos) {
      form.append('sasArquivoDocumentoOrdemCompraId', docs[0].anexoSolicitacaoEsclarecimentosTecnicos.id);
    }

    form.append('resposta', 'true');
    form.append(`arquivos`, values.arquivo);

    if (editando.sasPropostaId == record.id) {
      Modal.confirm({
        title: <>{editando.justificativa}</>,
        content: <ModalConfirmContentJustificativa
          texto='É necessário informar a justificativa para a alteração.'
          setJustificativa={e => {
            form.set('justificativaEdicao', e);
          }}
        />,
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        onOk: async (e) => {
          form.append('editando', 'true');
          return new Promise((resolve, reject) => {
            responderSolicitacaoEnvioEsclarecimentosTecnicos(form)
              .then((data: any) => {
                if (data && data.valid) {
                  onReloadVendorList();
                  setModalAcoesId('');
                  return resolve(true);
                } else {
                  if (data.notifications && data.notifications.length > 0) {
                    const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                      return c.property == 'justificativaEdicao';
                    });
                    if (erroJustificativaEdicao >= 0) {
                      return reject(false);
                    }
                  }
                }
              });
          });
        },
        onCancel: () => { setModalAcoesId(''); }
      });
    } else {
      return await responderSolicitacaoEnvioEsclarecimentosTecnicos(form)
        .then((data: any) => {
          if (data && data.valid) {
            onReloadVendorList();
            // msgTypeNotification(data.mensagem, ETypeNotification.INFO);
            return true;
          }
          return false;
        });
    }

    return;
  };

  const rejeitarSolicitacaoEnvioEsclarecimentosTecnicos = async (idRecord: string, values: any) => {

    Modal.confirm({
      title: 'Rejeitar Esclarecimentos Técnicos Solicitados',
      content: 'Deseja realmente rejeitar a esclarecimentos Técnicos Solicitados?',
      cancelText: 'Cancelar',
      onCancel: () => { },
      okText: 'Confirmar',
      onOk: () => {
        const form = new FormData();
        form.append('sasPropostaId', idRecord);
        form.append('resposta', 'false');

        if (editando.sasPropostaId == idRecord) {
          Modal.confirm({
            title: <>{editando.justificativa}</>,
            content: <ModalConfirmContentJustificativa
              texto='É necessário informar a justificativa para a alteração.'
              setJustificativa={e => {
                form.set('justificativaEdicao', e);
              }}
            />,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: async (e) => {
              form.append('editando', 'true');
              return new Promise((resolve, reject) => {
                responderSolicitacaoEnvioEsclarecimentosTecnicos(form)
                  .then((data: any) => {
                    if (data && data.valid) {
                      onReloadVendorList();
                      setModalAcoesId('');
                      return resolve(true);
                    } else {
                      if (data.notifications && data.notifications.length > 0) {
                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                          return c.property == 'justificativaEdicao';
                        });
                        if (erroJustificativaEdicao >= 0) {
                          return reject(false);
                        }
                      }
                    }
                  });
              });
            },
            onCancel: () => { setModalAcoesId(''); }
          });
        } else {
          return responderSolicitacaoEnvioEsclarecimentosTecnicos(form)
            .then((data: any) => {
              if (data && data.valid) {
                onReloadVendorList();
                setModalAcoesId('');
              }
            });
        }
      },
    });

  };

  const onSubmitCheckDocumentacao = (idRecord: string, resultadoCheckDocumentacao: string) => {
    updateCheckDocumentacao({
      sasPropostaId: idRecord || '',
      resultado: resultadoCheckDocumentacao,
      comentario: ""
    }).then((data: any) => {
      if (data && data.valid) {
        onReloadVendorList();
      }
    });
  };

  const excluirProposta = (id: string) => {
    Modal.confirm({
      title: 'Excluir Vendor',
      content: 'Deseja realmente excluir a participação do vendor?',
      cancelText: 'Cancelar',
      onCancel: () => { },
      okText: 'Confirmar',
      onOk: () => {
        deleteSasProposta(id)
          .then((data: any) => {
            if (data && data.valid) {
              setReload(!reload);
              onReloadVendorList();
            }
          });
      },
    });
  };

  const onSubmitPropostaTecnica = (idRecord: string, resultadoAvaliacaoTecnica: string) => {
    updatePropostaResultado({
      sasPropostaId: idRecord || '',
      resultadoAvaliacao: resultadoAvaliacaoTecnica,
      comentarioAvaliacao: "",
      propostaTecnica: true,
    }).then((data: any) => {
      if (data && data.valid) {
        onReloadVendorList();
        setModalAcoesId('');
      }
    });
  };

  const envioInformacoesCES = (sasPropostaId: string) => {
    Modal.confirm({
      title: 'Envio informações CES',
      // content: '',
      cancelText: 'Cancelar',
      onCancel: () => { },
      okText: 'Confirmar',
      onOk: () => {
        envioInformacoesCes(sasPropostaId, { sasPropostaId })
          .then((data: any) => {
            if (data && data.valid) {
              onReloadVendorList();
            }
          });
      },
    });
  };

  const columns = useMemo(() => {
    const columns: ColumnProps<SasProposta>[] = ([] = new Array());
    let ehAPartirDoPassoAnaliseDasPropostasComerciais = step.ordem >= 21;
    columns.push({
      title: 'código',
      dataIndex: 'codigoTotvs',
      width: '5%'
    });

    columns.push({
      title: 'fornecedor',
      dataIndex: 'sasFornecedorOcNome',
    });

    columns.push({
      title: 'status',
      dataIndex: 'statusSasPropostaNome',
      width: '10%',
      render: (text, record) => {
        return (
          <Row style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>{record.statusSasPropostaNome}</span>

            <Visibility visible={ehComprador && desabilitarAcoes === false}>
              <ModalEditarVendorStatus sasPropostaId={record.id} />
            </Visibility>
          </Row>
        );
      }
    });

    columns.push({
      title: 'informações',
      dataIndex: 'id',
      width: '10%',
      render: (text, record) => {
        return (
          <div>
            <Row align='middle' justify='center' style={{ display: 'flex' }} >
              <Visibility >
                <ModalExibicaoArquivos propostaId={record.id} fornecedorNome={record.sasFornecedorOcNome} disabled={desabilitarAcoes} />
              </Visibility>

              <Visibility visible={desabilitarAcoes === false}>
                <ModalInclusaoMultAnexo
                  buttonIcon="commons-plus"
                  buttonTooltip='Adicionar Documento'
                  buttonType='link'
                  onSubmit={async (values) => {
                    await incluirDocumento({
                      sasPropostaId: record.id,
                      ordemCompraId: ordemCompraId,
                      file: values.arquivo,
                      descricao: values.justificativa,
                      multiple: false,
                    });
                    return true;
                  }
                  }
                  showJustificativa
                  isJustificativaInput
                  labelJustificativa="Descrição do Documento"
                  placeholderJustificativa="Descrição do Documento"
                  textButtonSave="Salvar"
                  isMultAnexo={false}
                />
              </Visibility>

              <Visibility visible={ehComprador && desabilitarAcoes === false} >
                <ModalEditarVendor sasFornecedorOcId={record.sasFornecedorOcId} statusId={record.statusSasPropostaId} propostaId={record.id} />
              </Visibility>

              <Visibility visible={ehComprador && dadosGerais.tipo == ETipoDemanda.NovaContratacao && desabilitarAcoes === false}>
                <Space ml={4} />
                <Tooltip title="Excluir">
                  <Button icon='commons-trash' onClick={() => excluirProposta(record.id)} />
                </Tooltip>
                <Space ml={4} />
              </Visibility>

              <Visibility
                visible={hasPermissionPerfil([EGuidPerfilAcesso.GestorTecnico])}
              >
                <Tooltip title="Ir para Dados da Proposta">
                  <Button
                    key="dadosProposta"
                    icon="arrows-circled_up_right_2"
                    onClick={() => {
                      window.location.href = `${window.origin}/sasProposta/${record.id}`;
                    }}
                  />
                </Tooltip>
                <Space ml={4} />
              </Visibility>
            </Row>
          </div>
        );
      }
    });

     //if (c.StatusSolicitacaoEsclarecimentosTecnicos) {
    if (
      step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EsclarecimentosTecnicosSolicitados ||
      step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante  ||
      step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes 
    ) {
    
      columns.push({
        title: 'Status Esclarecimentos Técnicos',
        dataIndex: 'statusSolicitacaoEsclarecimentosTecnicos',
        width: '10%',
        render: (value: string) =>
          value === EStatusSolicitacaoEsclarecimentosTecnicos.NAO_APLICAVEL
            ? 'Não Solicitado'
            : value
      });
    }
    if (
      step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ParecerTecnico
    ) {

      columns.push({
        title: 'Status Parecer Técnico',
        dataIndex: 'statusResultadoParecerTecnico',
        width: '10%'
      });
    }
    //if (c.EnvioNegociacaoMinutaContratual) {
    if (
      step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioNegociacaoMinutaContratual
    ) {

      columns.push({
        title: 'Status Minuta Contratual',
        dataIndex: 'statusEnvioNegociacaoMinutaContratual',
        width: '10%'
      });
    }
    //}

    if (ehAPartirDoPassoAnaliseDasPropostasComerciais) {
      columns.push({
        title: "Ranking",
        dataIndex: 'ranking',
        align: 'center',
        render: (text, record) => (
          <Visibility visible={
            dadosGerais.tipo === ETipoDemanda.NovaContratacao
              ? record.ranking != 0 && record.valorPropostaComercialFormatada != "R$ 0,00"
              : record.ranking != 0
          }>
            <span>{record.ranking}</span>
          </Visibility>
        ),
        width: '100px'
      });
    }

    const stepAtual = allSteps.find(e => e.isAtual) || step;
    const stepRecebimentoPropostaComercial = allSteps.find(e => e.fluxoEtapaId === EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial);
    let temPropInicial = ehAditivo && stepRecebimentoPropostaComercial && stepAtual.ordem >= stepRecebimentoPropostaComercial.ordem
      ? true
      : data.findIndex(c => isObjNotEmpty(c.valorPropostaInicial)) > -1;

    if (temPropInicial) {
      columns.push({
        title: 'proposta inicial',
        dataIndex: 'valorPropostaInicialFormatada',
        width: '10%'
      });
    }

   

    if (dadosGerais.rodadasNegociacoes && dadosGerais.rodadasNegociacoes.length > 0) {
      dadosGerais.rodadasNegociacoes.map((rodada, index) => {
        columns.push({
          title: `${rodada.numero}ª rodada`,
          width: '10%',
          render(text, record, index) {
            const rodadaP = record.sasPropostaRodadaNegociacao.find(c => c.ordemCompraRodadaNegociacaoId == rodada.id);

            let valid = ehAditivo
              ? true
              : isObjNotEmpty(rodadaP) && isObjNotEmpty(rodadaP.valorAtualizado);

            if (rodadaP && isObjNotEmpty(rodadaP) && valid) {
              return rodadaP.valorAtualizadoFormatado;
            }
          },
        });
      });
    }

    // ações
    if (
      (
        hasPermission(['SAS_VISUALIZAR_PROPOSTA_FORNECEDOR']) ||
        hasPermissionPerfil([EGuidPerfilAcesso.GerenciaSenior, EGuidPerfilAcesso.AdministradorContratoMRN])
      ) && desabilitarAcoes === false
    ) {
      columns.push({
        title: 'ação',
        dataIndex: 'acoes',
        align: 'center',
        width: '5%',
        className: 'column-actions',
        render: (text, record, index) => {
          return (<ModalAcoesGerais
            child={acoes(record)}
            id={record.id}
            status={calcularStatus(record)}
            ehPropostaAtiva={record.statusSasPropostaNome === "Ativo"} />);
        },
      });
    }

    columns.push({
      title: 'status ação',
      dataIndex: 'statusAcao',
      align: 'center',
      width: '5%',
      render: (text, record, index) => calcularStatus(record)
    });

    return columns;
  }, [data, step, tmpIdAcoes, reload, reloadVendorList, ordemCompraRodadaNegociacaoId, editando.sasPropostaId, desabilitarAcoes, dadosGerais]);

  useMemo(() => {
    if (dadosGerais && dadosGerais.rodadasNegociacoes) {
      setRodadaPasso(dadosGerais.rodadasNegociacoes.find(c => c.id == ordemCompraRodadaNegociacaoId));
    }
  }, [ordemCompraRodadaNegociacaoId, reload, reloadVendorList]);

  const acoes = (record: SasProposta) => {
    const acoes: React.ReactNode[] = [];
    if (record.statusSasPropostaId !== EGuidStatusSasProposta.Ativa) return acoes;

    if (isObjEmpty(step)) return acoes;

    {/* AguardandoAnaliseComercial */ }
    if (statusCodigo === EStatusOrdemCompra.AguardandoAnaliseComercial) {
      if (record.statusResultadoAvaliacaoComercial === EStatusResultadoAvaliacaoComercial.APROVADO && (ehComprador || hasPermission(['SAS_ALTERAR_PROPOSTA_COMERCIAL']))) {
        acoes.push(
          <Tooltip title="Marcar como vencedor">
            <Button
              key="vencedor"
              icon="commons-ok"
              size="large"
              onClick={() => {
                confirm({
                  title: 'Marcar Vencedor',
                  icon: <Icon type="info-circle" />,
                  content: 'Deseja marcar este fornecedor como vencedor?',
                  onOk() {
                    updateVerdorVencedor({
                      ordemCompraId: ordemCompraId,
                      sasPropostaId: record.id,
                    }).then(() => {
                      onUpdateDadosGerais();
                    });
                  },
                  onCancel() { },
                });
                setModalAcoesId('');
              }}
            />
          </Tooltip>
        );
      }
    }

    {/* Envio carta à contratada */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioDaCartaConvite && dadosGerais && dadosGerais.tipo == ETipoDemanda.Aditivo) {
      acoes.push(
        <ModalEnvioComunicacaoContratada sasProposta={record} />
      );
    }

    {/* AceiteOuDeclinio carta convite */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AceiteOuDeclinio) {
      if (record.statusCartaConvite == EStatusCartaConvite.ENVIADA ||
        (
          (record.statusCartaConvite == EStatusCartaConvite.ACEITA ||
            record.statusCartaConvite == EStatusCartaConvite.DECLINOU) &&
          editando.sasPropostaId == record.id
        )
      ) {
        acoes.push(
          <ModalInclusaoMultAnexo
            buttonIcon="commons-ok"
            buttonTooltip='Aceitar Carta Convite'
            content='Incluir abaixo o email referente ao aceite da carta convite.'
            onSubmit={async (values) => {
              let result = false;
              await aceitarCartaConvite(record.id, values).then((data) => {
                result = data;
              });
              setModalAcoesId('');
              return result;
            }}
            showJustificativa={false}
            textButtonSave="Salvar"
            showDataOnTable
            onGetArquivos={async () => {
              return await getArquivosDocumentoOrdemCompraByOc({
                ordemCompraId: record.ordemCompraId,
                sasTipoDocumentoId: EGuidTipoSasDocumento.AceiteCartaConvite,
                sasPropostaId: record.id,
              }).then((data: any) => {
                return data || [];
              });
            }}
          />
        );
        acoes.push(
          <ModalInclusaoMultAnexo
            buttonIcon="commons-cancel"
            buttonTooltip='Declinar Carta Convite'
            content='Prezado, você confirma a NÃO participação do fornecedor neste processo de compra?'
            styleContent={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '30px' }}
            onSubmit={async (values) => {
              let result = false;
              await rejeitarCartaConvite(record.id, values).then((data) => {
                result = data;
              });
              setModalAcoesId('');
              return result;
            }}
            textButtonSave="Salvar"
            placeholderJustificativa="Justificativa de NÃO participação"
            showDataOnTable
            onGetArquivos={async () => {
              return await getArquivosDocumentoOrdemCompraByOc({
                ordemCompraId: record.ordemCompraId,
                sasTipoDocumentoId: EGuidTipoSasDocumento.RecusaCartaConvite,
                sasPropostaId: record.id,
              }).then((data: any) => {
                return data || [];
              });
            }}
          />
        );
      }
    }


    {/* VisitaTecnica */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.VisitaTecnica) {
      if (
        record.statusCartaConvite == EStatusCartaConvite.ACEITA
        && isObjEmpty(record.dataStatusVisitaTecnica)
        && isObjEmpty(record.statusVisitaTecnica)
      ) {
        acoes.push(
          <ModalInclusaoMultAnexo
            buttonIcon="commons-ok"
            buttonTooltip='Responder Visita Técnica'
            content='Incluir abaixo o email referente ao aceite da visita técnica.'
            onSubmit={async (values) => {
              let result = false;
              await aceitarVisitaTecnica(record.id, values).then((data) => {
                result = data;
              });
              setModalAcoesId('');
              return result;
            }}
            showJustificativa={false}
            textButtonSave="Salvar"
          />
        );

        acoes.push(
          <ModalInclusaoMultAnexo
            buttonIcon="commons-cancel"
            buttonTooltip='Confirma Não Participação na Visita Técnica'
            content='Prezado, você confirma a NÃO participação deste proponente na Visita Técnica?'
            styleContent={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '30px' }}
            onSubmit={async (values) => {
              let result = false;
              await rejeitarVisitaTecnica(record.id, values).then((data) => {
                result = data;
              });
              setModalAcoesId('');
              return result;
            }}
            textButtonSave="Salvar"
            placeholderJustificativa="Justificativa de NÃO participação"
          />
        );
      }
    }

   
        console.log('0')
    if (step && 'fluxoEtapaId' in step &&
      [
        EGuidFluxoProcessoEtapa.EsclarecimentosTecnicosSolicitados,
        EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante
      ].toString().includes(step.fluxoEtapaId)
    ) {
      if (
        (record.statusCartaConvite == EStatusCartaConvite.ACEITA || dadosGerais.tipo == ETipoDemanda.Aditivo) &&
        (
          (
            isObjEmpty(record.statusSolicitacaoEsclarecimentosTecnicos) ||
            (
            record.statusSolicitacaoEsclarecimentosTecnicos != EStatusSolicitacaoEsclarecimentosTecnicos.ENVIADO &&
            record.statusSolicitacaoEsclarecimentosTecnicos != EStatusSolicitacaoEsclarecimentosTecnicos.DUVIDAS_CONSOLIDADAS &&
            record.statusSolicitacaoEsclarecimentosTecnicos != EStatusSolicitacaoEsclarecimentosTecnicos.RESPOSTAS_ENVIADAS &&
            record.statusSolicitacaoEsclarecimentosTecnicos != EStatusSolicitacaoEsclarecimentosTecnicos.NAO_APLICAVEL 
            )
          ) 
          || editando.sasPropostaId == record.id
        )
      ) {

        
        console.log('2')
        acoes.push(
          <ModalInclusaoMultAnexo
            buttonIcon="commons-ok"
            buttonTooltip="Aceite Esclarecimentos Técnicos Solicitados"
            // content='Incluir abaixo o email referente ao aceite da visita técnica.'
            onSubmit={async (values) => {
              const result = await aceitarSolicitacaoEnvioEsclarecimentosTecnicos(record, values)
                .then((data: any) => {
                  return data;
                });
              setModalAcoesId('');
              return result;
            }}
            isMultAnexo={false}
            showJustificativa={false}
            textButtonSave="Salvar"
            onChangeOpen={(value: boolean) => {
              if (value) {
                getPropostasOrdemCompraDocs({
                  ordemCompraId: ordemCompraId,
                  sasPropostaId: record.id
                })
                  .then((result: any) => {
                    if (result) {
                      setDocs(result);
                    }
                  });
              }
            }}
          />
        );

        acoes.push(
          <Tooltip title="Recusa Esclarecimentos Técnicos Solicitados">
            <Button
              type='primary'
              key="SolicitacaoEnvioEsclarecimentosTecnicos"
              icon="commons-cancel"
              onClick={(values) => {
                rejeitarSolicitacaoEnvioEsclarecimentosTecnicos(record.id, values);
              }}
            />
          </Tooltip>
        );
      }
    }

    {/* RecebimentoPropostaTecnicasProponentes */ }
    if (EGuidFluxoProcessoEtapa.RecebimentoPropostaTecnicasProponentes == step.fluxoEtapaId) {
      if (isObjEmpty(record.statusSolicitacaoEsclarecimentosTecnicos) ||
        record.statusSolicitacaoEsclarecimentosTecnicos == EStatusSolicitacaoEsclarecimentosTecnicos.RESPOSTAS_ENVIADAS ||
        record.statusSolicitacaoEsclarecimentosTecnicos == EStatusSolicitacaoEsclarecimentosTecnicos.NAO_ENVIADO ||
        record.statusSolicitacaoEsclarecimentosTecnicos == EStatusSolicitacaoEsclarecimentosTecnicos.NAO_APLICAVEL
      ) {
        if ((isObjEmpty(tmpIdAcoes) || isObjNotEmpty(tmpIdAcoes) && tmpIdAcoes.includes(record.id) == false)
          && (isObjEmpty(record.statusPropostaTecnica) || isObjEmpty(record.dataStatusPropostaTecnica))) {
          acoes.push(<Tooltip title="Recebimento Proposta Técnica">
            <Button
              key="RecebimentoPropostaTecnica"
              icon="commons-ok"
              onClick={() => {
                setTmpIdAcoes([...tmpIdAcoes, record.id]);
              }}
            />
          </Tooltip>);
        }
      }

      if (isObjNotEmpty(tmpIdAcoes) && tmpIdAcoes.includes(record.id) || (isObjNotEmpty(record.statusPropostaTecnica) && isObjNotEmpty(record.dataStatusPropostaTecnica))) {
        if (record.statusPropostaTecnica == "Recebida" || isObjEmpty(record.statusPropostaTecnica)) {
          acoes.push(
            <ModalRecebimentoPropostaTecnica record={record} />
          );
        }

        if (record.statusPropostaTecnica != "Recebida" || isObjEmpty(record.statusPropostaTecnica)) {
          acoes.push(
            <ModalNaoRecebimentoPropostaTecnica
              sasPropostaId={record.id}
              sasProposta={record}
              tipoOrdemCompra={dadosGerais.tipo}
              tipoContrato={dadosGerais.tipoContrato} />
          );
        }
      }

    }

    {/* AvaliacaoPropostasTecnicas */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AvaliacaoPropostasTecnicas) {
      acoes.push(
        <UploadModalHistorico
          buttonIcon={'commons-download_2'}
          tooltip="Proposta Técnica recebida do fornecedor"
          title="Proposta Técnica recebida do fornecedor"
          hasJustification={false}
          hasDatePicker={false}
          hasUpload={false}
          onGetArquivos={async () => {
            return await getArquivosDocumentoOrdemCompraByOc({
              ordemCompraId,
              sasTipoDocumentoId: EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes,
              sasPropostaId: record.id,
            }).then((data) => {
              return data || [];
            });
          }}
          arquivoActions={{
            onDownload: (arquivo: IArquivo) => {
              downloadArquivo(
                arquivo.id,
                arquivo.nome
              );
            },
            onView(arquivo: IArquivo) {
              viewArquivo(
                arquivo.id,
                arquivo.nome
              );
            },
          }}
          onDownloadAllArquivos={async () => {
            await downloadArquivosOrdemCompra({
              ordemCompraId: dadosIdentificacao.id,
              ordemCompraNumero: dadosIdentificacao.numero,
              nomeArquivo: 'avaliacao_proposta_tecnicas',
              sasTipoDocumentoOrdemCompraId: EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes,
              sasPropostaId: record.id
            });
          }}
        />
      );

      if (ehComprador) {
        acoes.push(
          <ModalPropostaTecnicaConsolidada sasPropostaId={record.id} />
        );
      }

      acoes.push(
        <Col >
          <Select
            style={{ width: '120px' }}
            defaultValue={getByText(optionsAvaliacaoSasPropostaTecnica, record.statusResultadoAvaliacaoTecnica ? record.statusResultadoAvaliacaoTecnica : "Em Revisão")}
            onSelect={(e: any) => {
              onSubmitPropostaTecnica(record.id, e);
            }}
          >
            {optionsAvaliacaoSasPropostaTecnica.map(option => {
              return (<Select.Option value={option.value}>{option.text}</Select.Option>);
            })}
          </Select>
        </Col>
      );

    }

    {/* FluxoGenericoRodadaNegociacao */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao) {
      const propostaRodada = record.sasPropostaRodadaNegociacao.find(c => c.ordemCompraRodadaNegociacaoId == ordemCompraRodadaNegociacaoId);

      if (
        (isObjEmpty(tmpIdAcoes) || (isObjNotEmpty(tmpIdAcoes) && tmpIdAcoes.includes(record.id) == false)) &&
        propostaRodada === undefined
      ) {
        acoes.push(
          <Tooltip title="Cadastro Rodada de Negociações">
            <Button
              key="cadastroRodadaNegociacoes"
              icon="commons-ok"
              onClick={() => {
                setTmpIdAcoes([...tmpIdAcoes, record.id]);
              }}
            />
          </Tooltip>
        );
      }
      if (
        isObjNotEmpty(tmpIdAcoes) && tmpIdAcoes.includes(record.id) ||
        propostaRodada !== undefined || editando.sasPropostaId == record.id
      ) {
        acoes.push(
          <BotoesSasPropostaRodadaNegociacao
            sasProposta={record}
          />
        );
      }
    }

    {/* SolicitacaoAvaliacaoFinanceira */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoAvaliacaoFinanceira) {

      if (
        record.statusRelatorioConfide !== EStatusRelatorioConfide.RECEBIDO ||
        editando.sasPropostaId == record.id
      ) {
        acoes.push(<ModalStatusRelatorioConfide sasProposta={record} />);
      }

      if (
        (record.statusRelatorioConfide === EStatusRelatorioConfide.RECEBIDO &&
          record.statusSolicitacaoAvaliacaoFinanceira !== EStatusSolicitacaoAvaliacaoFinanceira.ENVIADO) ||
        editando.sasPropostaId == record.id
      ) {
        acoes.push(<ModalSolicitacaoAvaliacaoFinanceira sasProposta={record} />);
      }
    }

    {/* CadastroResultadoAvaliacaoFinanceira */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.CadastroResultadoAvaliacaoFinanceira) {
      if (record.statusSolicitacaoAvaliacaoFinanceira === EStatusSolicitacaoAvaliacaoFinanceira.ENVIADO) {
        acoes.push(<ModalCadastroResultadoAvaliacaoFinanceira sasProposta={record} />);
      }
    }

    {/* EnvioNegociacaoMinutaContratual */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.EnvioNegociacaoMinutaContratual) {
      if ((record.statusEnvioNegociacaoMinutaContratual !== "Minuta Validada" || editando.sasPropostaId == record.id) &&
        record.numeroVencedor === 1) {
        if (record.statusEnvioNegociacaoMinutaContratual !== "Em negociação" || editando.sasPropostaId == record.id) {
          acoes.push(<BotoesEnvioNegociacaoMinutaContratual sasProposta={record} />);
        }

        acoes.push(<Space ml={16} />);

        if (record.statusEnvioNegociacaoMinutaContratual === "Em negociação" || editando.sasPropostaId == record.id) {
          acoes.push(<ModalValidarMinutaEnvioNegociacaoMinutaContratual sasProposta={record} />);
        }

        acoes.push(<Space ml={4} />);

        if (editando.sasPropostaId == record.id) {
          acoes.push(<ModalComunicacaoMinutaContratualFornecedor sasProposta={record} />);
        }
      }
    }

    {/* SolicitacaoChancelaGJMinuta */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoChancelaGJMinuta) {
      if (
        ((record.statusConfirmarSolicitacaoChancelaGJMinuta !== "Chancelado" &&
          record.statusConfirmarSolicitacaoChancelaGJMinuta !== "Dispensado") ||
          editando.sasPropostaId == record.id) && record.numeroVencedor === 1
      ) {

        if (record.statusConfirmarSolicitacaoChancelaGJMinuta !== "Enviado" || editando.sasPropostaId == record.id) {
          acoes.push(<ModalConfirmarSolicitacaoChancelaGJMinuta sasProposta={record} />);
        }

        if (
          record.statusConfirmarSolicitacaoChancelaGJMinuta === "Enviado" ||
          (record.statusConfirmarSolicitacaoChancelaGJMinuta === "Chancelado" && editando.sasPropostaId == record.id)
        ) {
          acoes.push(<ModalRegistroSolicitacaoChancelaGJMinuta sasProposta={record} />);
        }

        if (record.botoesChancela.includes("Dispensavel")) {
          acoes.push(<ModalDispensarSolicitacaoChancelaGJMinuta sasProposta={record} />);
        }
      }
    }

    {/* EnvioInformaçõesAdmContratosProvidenciarCES */ }
    if (false) {
      acoes.push(
        <Tooltip title="Envio informações CES">
          <Button
            key="envioInformacoesCES"
            icon="commons-ok"
            onClick={() => {
              setModalAcoesId('');
              envioInformacoesCES(record.id);
            }}
          />
        </Tooltip>
      );
      acoes.push(
        <Tooltip title="Relatório CES">
          <Button
            key="relatorioCES"
            icon="business-set_as_resume"
            onClick={() => {

            }}
          />
        </Tooltip>
      );
    }

    {/* VerificacaoHomologacaoFornecedor */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.VerificacaoHomologacaoFornecedor) {
      acoes.push(<ModalHomologacao sasPropostaId={record.id} sasProposta={record} />);
    }

    {/* SolicitacaoCONFIDE */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.SolicitacaoCONFIDE) {
      if (
        record.statusResultadoEnvioConfide !== "Desobrigado" ||
        editando.sasPropostaId == record.id
      ) {
        acoes.push(<ModalEnviarConfide sasProposta={record} />);
      }
      if (
        record.statusResultadoEnvioConfide !== "Enviado" ||
        editando.sasPropostaId == record.id
      ) {
        acoes.push(<ModalDesobrigarRelatorioFinanceiro sasProposta={record} />);
      }
    }

    {/* RecebimentoFormularioDDIProponentesEnvioParaDPC */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoFormularioDDIProponentesEnvioParaDPC) {
      acoes.push(<ModalEnvioDPC sasProposta={record} />);
    }

    {/* CadastroParecerDoDPCQuantoADDI */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.CadastroParecerDoDPCQuantoADDI) {
      if (!(record.envioDPC && record.envioDPC.includes("Não Enviado"))) {
        acoes.push(<ModalParecerDPC sasProposta={record} />);
      }
    }

    {/* RecebimentoPropostaComercial */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial) {
      acoes.push(<ButtonConfirmarPropostaComercial sasPropostaId={record.id} sasProposta={record} />);
    }

    {/* Parecer Técnico */ }
    if (step.fluxoEtapaId == EGuidFluxoProcessoEtapa.ParecerTecnico) {
      if (
        (record.statusSasPropostaId == EGuidStatusSasProposta.Ativa) ||
        (record.statusResultadoParecerTecnico.toLowerCase() === 'reprovado') ||
        (record.statusResultadoParecerTecnico.toLowerCase() === 'aprovado')
      ) {
        acoes.push(<ModalParecerTecnico sasProposta={record} />);
        if (ehComprador && record.statusResultadoParecerTecnico === 'Aguardando Comprador') {
          acoes.push(<ModalAcoesCompradorParecerTecnico sasProposta={record} />);
        }
      }
    }

    console.log(acoes)
    return acoes;
  };

  const calcularStatus = (record: ISasPropostaOrdemCompra) => {
    let item = undefined;
    if (ordemCompraRodadaNegociacaoId) {
      item = record.sasPropostaStatusOrdemCompraFluxoProcesso.find(c => c.ordemCompraRodadaNegociacaoId == ordemCompraRodadaNegociacaoId);
    } else {
      item = record.sasPropostaStatusOrdemCompraFluxoProcesso.find(c => (c.fluxoProcessoId == step.fluxoEtapaId && c.ordemCompraRodadaNegociacaoId == null));
    }
    return item ? item.status : 'N/A';
  };

  return (
    <>
      <Table
        className="tabela-vendor-list"
        columns={columns}
        dataSource={data}
        rowKey={'id'}
        pagination={false}
        rowClassName={(record, index) => record.numeroVencedor ? 'row-vencedor' : ''}
        style={{ marginBottom: 10 }}
      />
      <Visibility visible={isValidGuid(showModalDesobrigarConfideId)} >
        <ModalDesobrigarConfide />
      </Visibility>
      <Row style={{ marginBottom: '16px' }}>
        <Visibility
          visible={
            step.fluxoEtapaId === EGuidFluxoProcessoEtapa.DefinicaoVendorList
            && desabilitarAcoes === false
            && (
              hasPermission(['SAS_FORNECEDOR_INCLUIR'])
              || hasPermissionPerfil([EGuidPerfilAcesso.GerenciaSenior, EGuidPerfilAcesso.AdministradorContratoMRN])
            )
            && (dadosGerais.tipo == ETipoDemanda.NovaContratacao || dadosGerais.tipo == ETipoDemanda.FaturamentoDireto)
          }
        >
          <ModalIncluirVendor ordemCompraId={ordemCompraId} />
        </Visibility>

        <Visibility
          visible={step.fluxoEtapaId == EGuidFluxoProcessoEtapa.AvaliacaoPropostasTecnicas}
        >
          <Button
            style={{ float: 'right' }}
            type='primary'
            onClick={async () => {
              await downloadArquivosOrdemCompra({
                ordemCompraId: dadosIdentificacao.id,
                ordemCompraNumero: dadosIdentificacao.numero,
                nomeArquivo: `avaliacao_propostas_tecnicas`,
                sasTipoDocumentoOrdemCompraId: EGuidTipoSasDocumento.AceiteRecebimentoPropostaTecnicasProponentes,
                isPropostas: true
              });
            }}>
            Baixar Tudo
          </Button>
        </Visibility>
      </Row>
    </>
  );
};

export default TableVendorList;
